import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
`;
